
import { mapGetters } from "vuex";
import MenuComboActionTile from "./menu-combo-action-tile.vue";
import MenuComboItemRowWithSwitch from "./menu-combo-item-row-with-switch.vue";
import MenuItemRowWithPriceAndSwitch from "./menu-item-row-with-price-and-switch.vue";
import menuNormalItemActionTile from "./menu-normal-item-action-tile.vue";
export default {
  components: {
    menuNormalItemActionTile,
    MenuItemRowWithPriceAndSwitch,
    MenuComboItemRowWithSwitch,
    MenuComboActionTile
  },
  data() {
    return {
      panel: "",
      active: [],
      renderItems: [],
      intersectionOptions: {
        root: null,
        rootMargin: "0px 0px 0px 0px",
        threshold: [0, 1]
      }
    };
  },
  props: {
    items: {},
    subcategories: {},
    highlightText: ""
  },
  beforeMount() {
    this.renderList();
  },
  watch: {
    items() {
      this.addRenderItems();
    }
  },
  computed: {
    ...mapGetters("restaurant", ["hasMultipleBrands"])
  },
  methods: {
    renderList() {
      this.renderItems = [];
      this.addRenderItems();
      // this.renderInterval = setInterval(
      //   function() {
      //     if (this.renderItems.length === this.items.length) {
      //       clearInterval(this.renderInterval);
      //     } else {
      //       this.addRenderItems();
      //     }
      //   }.bind(this),
      //   500
      // );
    },
    addRenderItems() {
      // this.renderItems.push(
      //   ...this.items.slice(
      //     this.renderItems.length,
      //     this.renderItems.length + 10
      //   )
      // );
      this.renderItems = this.items.slice(0, this.renderItems.length + 10);
    },
    onWaypoint({ going, direction }) {
      if (going === "in") {
        this.addRenderItems();
      }
    },
    handleHeaderClick(item) {
      if (!this.$vuetify.breakpoint.mdAndUp) {
        this.$emit("open-expansion-content", item);
      }
    }
  }
};
